import { apiFetch } from "../client"

export async function listLoans(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/loans${query}`)
}

export async function getLoan(loanId: string) {
  return apiFetch<any>(`/loans/${loanId}`)
}

export async function listLoanRepayments(loanId: string) {
  return apiFetch<any>(`/loans/${loanId}/repayments`)
}

export async function recordLoanRepayment(loanId: string, payload: Record<string, unknown>) {
  return apiFetch<any>(`/loans/${loanId}/repayments`, {
    method: "POST",
    rawBody: payload,
  })
}

export async function listDisbursements(params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : ""
  return apiFetch<any>(`/disbursements${query}`)
}

export async function getDisbursement(disbursementId: string) {
  return apiFetch<any>(`/disbursements/${disbursementId}`)
}

function postAction(disbursementId: string, action: string, payload: Record<string, unknown>) {
  return apiFetch<any>(`/disbursements/${disbursementId}/${action}`, {
    method: "POST",
    rawBody: payload,
  })
}

export function approveDisbursement(disbursementId: string, payload: Record<string, unknown>) {
  return postAction(disbursementId, "approve", payload)
}

export function holdDisbursement(disbursementId: string, payload: Record<string, unknown>) {
  return postAction(disbursementId, "hold", payload)
}

export function rejectDisbursement(disbursementId: string, payload: Record<string, unknown>) {
  return postAction(disbursementId, "reject", payload)
}

export function retryDisbursement(disbursementId: string, payload: Record<string, unknown>) {
  return postAction(disbursementId, "retry", payload)
}

export function manualCompleteDisbursement(
  disbursementId: string,
  payload: Record<string, unknown>,
) {
  return postAction(disbursementId, "manual-complete", payload)
}

export function manualFailDisbursement(disbursementId: string, payload: Record<string, unknown>) {
  return postAction(disbursementId, "manual-fail", payload)
}
